<template>
  <table class="table">
    <thead>
      <tr>
        <th></th>
        <th>Id</th>
        <th>Rev.</th>
        <th>Details</th>
        <th>Topic</th>
        <th class="u-text-left" colspan="2">Question</th>
      </tr>
    </thead>
    <tbody>
      <tr v-if="questionList.length == 0">
        <td colspan="7">
          <no-results-found
            title="No Results Found"
            message="Maybe change the search and filters and try again?"
          ></no-results-found>
        </td>
      </tr>
      <tr
        v-else
        v-for="question in questionList"
        :key="question.id"
        v-bind:class="{ inactive: !question.is_active }"
      >
        <td>
          <button
            class="btn-small u-center"
            v-bind:class="
              permissions.includes('exams.change_question')
                ? 'btn-primary'
                : 'btn-info'
            "
          >
            <router-link
              :to="{ name: 'question', params: { id: question.id } }"
            >
              {{
                permissions.includes("exams.change_question") ? "Edit" : "View"
              }}
            </router-link>
          </button>
        </td>
        <td>
          <button
            class="btn btn-small outline btn-transparent"
            v-on:click="$emit('getQuestionHistory', question.uuid)"
          >
            {{ handleUUID(question.uuid) }}
          </button>
        </td>
        <td>
          {{ question.revision }}
        </td>
        <td class="u-text-right">
          <question-status v-bind:question="question"></question-status>
        </td>
        <td>{{ question.topic.name }}</td>
        <td class="u-text-left u-trim-text">
          {{ question.text | truncate(128, "...") }}
        </td>
        <td>
          {{ question.marks }} mark<span v-if="question.marks > 1">s</span>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<style>
td div.tag-container {
  flex-wrap: nowrap;
}
.inactive {
  pointer-events: "none";
  background: #d5d7dc;
}
</style>
<script>
import { mapGetters } from "vuex";
import QuestionStatus from "@/components/questions/QuestionStatus";
import NoResultsFound from "@/components/PlaceholderNoResults";

export default {
  name: "question-table",
  components: {
    QuestionStatus,
    NoResultsFound
  },
  props: {
    error: {},
    questionList: Array
  },
  computed: {
    ...mapGetters("auth", ["permissions"])
  },
  methods: {
    handleUUID: function(uuid) {
      return "..." + uuid.slice(-7, -1);
    }
  }
};
</script>
